import { createContext, useContext } from 'react';
import { layout } from '../theme';
import useWindowDimensions from './WindowDimensions';

export const SidebarLayoutContext = createContext({ expanded: false, mobile: false });

// Tables size themselves from the window width, tuned for the collapsed sidebar rail.
// Subtract the extra space taken by the expanded sidebar so they fit the content area.
export default function useLayoutDimensions() {
  const { width, height } = useWindowDimensions();
  const { expanded, mobile } = useContext(SidebarLayoutContext);
  const expandedSidebarExtra =
    expanded && !mobile ? layout.sidebar - layout.sidebarRail : 0;

  return { width: width - expandedSidebarExtra, height };
}
